<template>
    <div id="crumbs" class="background-white">
        <el-breadcrumb class="crumbs" separator="/" :replace="true">
			<el-breadcrumb-item v-for="(list, index) in data" :key="index" :to="list.path">{{ list.title }}</el-breadcrumb-item>
		</el-breadcrumb>
    </div>
</template>

<script>
export default {
	name: 'crumbs',
	data () {
		return {
			data: []
		}
	},
	watch: {
		$route (to, from) {
			this.checkCrumbs(to)
  		}
	},
	methods: {
		checkCrumbs (title) { //处理面包屑导航
			this.data = []
			var text = title.name.split('/'),
				path = title.fullPath.split('/')
				path.splice(0, 1)
			for (var i = 0, len = text.length; i < len; i++) {
				this.data.push({
					title: text[i],
					path: this.getPath(i, len, path)
				})
			}
		},
		getPath (index, leng, path) {
			var value = ''
			for (var i = 0; i < index + 1; i++) {
				value += '/' + path[i]
			}
			return value
		}
	},
	mounted () {
		this.checkCrumbs(this.$route)
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#crumbs{width: 100%;height: 40px; background:#EDEFF5;}
#crumbs .crumbs{width: 100%;height: 40px;line-height: 40px;padding: 0 30px;box-shadow: 0 5px 10px -5px #e3e3e3;}
</style>



// WEBPACK FOOTER //
// src/components/crumbs.vue